import { Button, Column, Grid } from "@carbon/react";
import { Add, ArrowUpLeft } from "@carbon/react/icons";

import { ActivationBanner, PageBanner } from "../../components";
import { BalanceTable } from "./BalanceTable";


export const View = (props) => {
  return (
    <>
      <PageBanner
        pageTitle={""}
        pageSubtitle={"Please add your preferred bank account"}
        pageDescription={"Add a bank account to pay out your balance."}
        linkTitle={""}
        linkSubtitle={""}
        linkButtonText={"Add bank account"}
        linkButtonUrl={"add-bank-account"}
        linkButtonIcon={<Add />}
        linkButtonIconLeft
        linkButtonClassName={"float-right mr-5"}
      />

      <ActivationBanner
        title="To create a payment link, you need to activate your profile"
        subtitle="Our guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <div className="flex-container justify-content--end mb-5">
        <Button
          // onClick={onExport}
          size="sm"
          className="switchapp-themed"
          iconDescription="Payout to bank"
        >
          <ArrowUpLeft size={18} />
          Payout to bank
        </Button>

        <Button
          // onClick={onCreateNew}
          size="sm"
          kind="tertiary"
          className="switchapp-themed create-new-button"
          iconDescription="Add to balance"
        >
          <Add size={18} />
          Add to balance
        </Button>
      </div>

      <BalanceTable />
    </>
  );
};
